import {
	Column,
	Text,
} from 'native-base';
import {
	SOCKET_STATUS__OPEN,
	SOCKET_STATUS__CLOSED,
	SOCKET_STATUS__CONNECTING,
	SOCKET_STATUS__RETRYING,
	SOCKET_STATUS__FAILED,
	SOCKET_STATUS__CLOSING,
	SOCKET_STATUS__REFUSED,
} from '../../constants/Chat';
import { useSelector } from 'react-redux';
import {
	selectChatIsSocketConnected,
	selectChatSocketStatus,
} from '../../models/Slices/AppSlice';
import AppGlobals from '../../AppGlobals.js';
import _ from 'lodash';


export default function ConnectionStatus(props) {
	const
		chatIsSocketConnected = useSelector(selectChatIsSocketConnected),
		chatSocketStatus = useSelector(selectChatSocketStatus),
		retryAttempt = AppGlobals.chatManager.retryAttempt;

	let msg = '';
	switch(chatSocketStatus) {
		case SOCKET_STATUS__OPEN:
			msg = 'Connected';
			break;

		case SOCKET_STATUS__CONNECTING:
			msg = 'Connecting...';
			break;

		case SOCKET_STATUS__RETRYING:
			msg = 'Trying to reconnect...';
			if (retryAttempt > 1) {
				msg += "\n" + ' (attempt #' + retryAttempt + ')';
			}
			break;

		case SOCKET_STATUS__CLOSING:
			msg = 'Connection closing.';
			break;

		case SOCKET_STATUS__CLOSED:
			msg = "Connection closed.\nChatting is disabled until connection is re-established.";
			break;

		case SOCKET_STATUS__REFUSED:
			msg = "Connection was refused.\nWill try to reconnect after two minutes.";
			break;
			
		case SOCKET_STATUS__FAILED:
			msg = "Failed to Connect.\nWill try to reconnect after two minutes.";
			break;

		default:
			msg = !chatIsSocketConnected ? 'Socket is not connected' : 'Unknown';
	}

	return <Column
				flex={1}
				w="100%"
				alignItems="center"
				justifyContent="center"
				safeArea
			>
				<Text p={10} textAlign="center">{msg}</Text>
			</Column>;
}
